export interface UnknownObject {
  [key: string]: unknown;
}
